import { HOSPICE_DEALS } from '../sharedConfig';

// budgetAllocation values are relative weights, NOT percentages.
// The formula (weight / sumOfSelectedWeights) × sourceBudget distributes 100%
// of the source line item's budget across whichever items are enabled.
export default {
  key: 'hospice',
  label: 'Hospice',
  strategySets: {
    default: {
      label: 'Standard (5 items)',
      lineItems: [
        { name: 'CPM_Broad_x_x_49plus_DIS_Prospecting', segment: 'BROAD_49_PLUS', budgetAllocation: 20 },
        // contextualTarget REMOVED 2026-09: zero matches across all 204 Nexxen
        // inventory lists (backend-verified) — re-attach once the list exists.
        // TODO re-add: contextualTarget: 'Care Giver Intent_CT'
        { name: 'CPM_CT_CareGiverIntent_x_18plusonly_DIS_Prospecting', segment: 'AGE_18_PLUS_BROAD', budgetAllocation: 6.667 },
        // contextualTarget REMOVED 2026-09: zero matches across all 204 Nexxen
        // inventory lists (backend-verified) — re-attach once the list exists.
        // TODO re-add: contextualTarget: 'Lifestage & Eldercare_Contextual'
        { name: 'CPM_CT_Lifestage_Eldercare_x_18plusonly_DIS_Prospecting', segment: 'AGE_18_PLUS_BROAD', budgetAllocation: 6.666 },
        // contextualTarget REMOVED 2026-09: zero matches across all 204 Nexxen
        // inventory lists (backend-verified) — re-attach once the list exists.
        // TODO re-add: contextualTarget: 'Clinical Education_Contextual'
        { name: 'CPM_CT_ClinicalEducation_x_18plusonly_DIS_Prospecting', segment: 'AGE_18_PLUS_BROAD', budgetAllocation: 6.667 },
        { name: 'CPM_CQ_x_x_18plusonly_DIS_Conquesting', segment: 'AGE_18_PLUS_BROAD', budgetAllocation: 60 },
      ],
    },
  },
  deals: HOSPICE_DEALS,
};
